import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDBox, FDStack } from '@facet-wealth/design';
import { CarouselControls } from 'Packages/FacetDesign/Components/Experimental/Carousel/CarouselControls';
import PropTypes from 'prop-types';

const useStyles = buildUseStyles('Carousel', (_) => ({
  swiper: {
    zIndex: 0, // For some reason the swiper styles set this to have a z-Index of 1 which will overlap our bottom wizard stepper
  },
}));

export const Carousel = ({ maxCardsVisible, cardWidth, children }) => {
  const theme = useTheme();
  const classes = useStyles();

  const allCards = React.Children.toArray(children);
  const additionalCardsExist = allCards.length > maxCardsVisible;

  if (!additionalCardsExist) {
    return (
      <FDStack alignItems={'flex-start'} justifyContent={'center'} spacing={2} width={'100%'}>
        {allCards}
      </FDStack>
    );
  }

  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={2} width={'100%'}>
      <FDBox maxWidth={Math.floor(maxCardsVisible) * cardWidth} width={'100%'}>
        <Swiper
          className={classes.swiper}
          grabCursor
          spaceBetween={theme.spacing(2)}
          slidesPerView={maxCardsVisible}
        >
          {/* eslint-disable-next-line react/no-array-index-key -- we have nothing better to use here */}
          {allCards.map((c, i) => <SwiperSlide key={i}>{c}</SwiperSlide>)}
          {additionalCardsExist ? <CarouselControls numCards={allCards.length} maxCardsVisible={maxCardsVisible} /> : null}
        </Swiper>
      </FDBox>
    </FDStack>
  );
};

Carousel.defaultProps = {
  maxCardsVisible: 3.1, // The decimal point tells us to show a portion of the next card if one exists. So this will show 3 full cards and 1/10th of the 4th
  cardWidth: 360,
};

Carousel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  maxCardsVisible: PropTypes.number,
  cardWidth: PropTypes.number,
};
